import { Country } from '@axo/config/@types/Country.types';
import { Language } from '@axo/config/@types/Language.types';
import { ReactElement } from 'react';
import { BankID } from './BankID';
import { MitID } from './MitID';

export type CriiptoProvidersProps = {
  action?: 'login' | 'continue';
  language?: Language;
  country: Country;
  /** deprecated */
  label?: string;
  href: string;
  onClick: () => void;
};

type CriiptoProvidersViewComponent = (
  props: CriiptoProvidersProps
) => ReactElement | null;

export const criiptoProvidersViewMap: Partial<
  Record<Country, CriiptoProvidersViewComponent>
> = {
  DK: MitID,
  NO: BankID,
  SE: BankID,
};
